import { MenuItemsGroup } from "@/api/types/helpers/types";
import { UserInfoDto } from "@/api/types/main/schemas";
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { NavLink } from "react-router-dom";

const ServicesNavGroup = ({
  servicesMenuItems,
  user,
}: {
  servicesMenuItems: Omit<MenuItemsGroup, "department">[];
  user: UserInfoDto;
}) => {
  const filteredServicesMenuItems = servicesMenuItems
    .map((group) => ({
      ...group,
      menuItems: group.menuItems.filter(
        (item) => item.role.includes(user.role) || item.role === "all"
      ),
    }))
    .filter((group) => group.menuItems.length > 0);

  return (
    <SidebarGroup>
      <SidebarGroupLabel>Сервисы: </SidebarGroupLabel>
      <SidebarMenu>
        {filteredServicesMenuItems.map((group) =>
          group.menuItems.map((item) => (
            <SidebarMenuItem key={item.path}>
              <SidebarMenuButton asChild tooltip={item.label}>
                <NavLink to={item.path}>
                  {item.icon && <item.icon />}
                  <span>{item.label}</span>
                </NavLink>
              </SidebarMenuButton>
            </SidebarMenuItem>
          ))
        )}
      </SidebarMenu>
    </SidebarGroup>
  );
};
export default ServicesNavGroup;
